import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "nav nav-pills align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mas py-1" }, "language"),
  /*#__PURE__*/_createElementVNode("span", { class: "mas" }, "arrow_right")
], -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "mas ms-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (
    this.isReady && (
      _ctx.forceMultilingualSupport
      || _ctx.AbilityContext.isAuthorizedForFeature('MULTILINGUAL')
      || _ctx.AbilityContext.isAuthorizedForAnyLicense('CP_PHARMA_PIM', 'CP_PRODUCT_CATEGORY', 'CP_LABO')
    ))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass('mb-' + this.mb)
      }, [
        _createElementVNode("ul", _hoisted_1, [
          _hoisted_2,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.languages, (language) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "nav-item",
              key: language
            }, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link d-flex align-items-center fw-600 px-2 py-1", {
            'active': this.activeLanguage === language,
            'text-danger': this.activeLanguage !== language && this.languageHasErrors(_ctx.errors, language),
            'text-bg-danger': this.activeLanguage === language && this.languageHasErrors(_ctx.errors, language),
           }]),
                href: "javascript:void(0)",
                onClick: ($event: any) => (this.$emit('updateActiveLanguage', language))
              }, [
                _createElementVNode("span", null, _toDisplayString(language.toUpperCase()), 1),
                (this.languageHasErrors(_ctx.errors, language))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "error"))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_3)
            ]))
          }), 128))
        ])
      ], 2))
    : _createCommentVNode("", true)
}